module.exports = __webpack_public_path__ + "static/opensans-semibolditalic-webfont-7e9147e8e071c6a7cedc392c044015a1.woff";